import { SpecialAnchorTypes, ToolTypes } from '@labradorsports/constants';

import {
    generateOptionAnchors,
    generateOptionLines,
    generateOptionSelectedAnchors,
    getDefaultOptionMove,
    handleOptionDrag,
    handleOptionDragEnd,
} from '../utils/index.js';

import { PluginContext } from './api.js';

export default {
    types: [ToolTypes.OPTION, SpecialAnchorTypes.OPTION_START],
    generateAnchors: generateOptionAnchors,
    generateSelectedAnchors: generateOptionSelectedAnchors,
    generateLines: generateOptionLines,
    handleDragEnd: handleOptionDragEnd,
    handleDrag: handleOptionDrag,
    getDefaultMove: getDefaultOptionMove,
} as PlayPlugin<PluginContext>;
